import Shipping from '../src/Shipping/index';
export default Shipping;
